import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 border-round-xl surface-100" }
const _hoisted_2 = { class: "flex mb-2 align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = { class: "flex-1 justify-content-center" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "flex p-2 mt-2 border-top-2 border-white" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 1,
  class: "py-8 text-center text-color-secondary text-sm"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import Chart from 'primevue/chart';
import { useReviewReportStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportAttendance',
  setup(__props) {

const { therapyResult } = storeToRefs(useReviewReportStore());

const colors = [
  {
    style: 'dark-green',
    hex: '#078888',
  },
  {
    style: 'green',
    hex: '#8BCFCF',
  },
  {
    style: 'blue',
    hex: '#40B3DD',
  },
  {
    style: 'orange',
    hex: '#EDA745',
  },
  {
    style: 'purple',
    hex: '#7E78D2',
  },
  {
    style: 'pink',
    hex: '#D49BC1',
  },
  {
    style: 'yellow',
    hex: '#FFD500',
  },
];

const totals = ref([]);

const totalResults = ref(0);

const chartData = ref({
  datasets: [
    {
      data: [],
      backgroundColor: [],
    },
  ],
});

watch(
  () => therapyResult.value.loading,
  () => defineTotals(),
);

const hasTotals = computed(() => Object.keys(therapyResult.value.data).length);

const absoluteTotal = computed(() => new Intl.NumberFormat().format(totalResults.value));

const defineTotals = () => {
  if (!therapyResult.value.loading) {
    //  Reset the sum of results on every refresh.
    totalResults.value = 0;

    // Calculate the new sum total.
    therapyResult.value.data.forEach(({ total }) => (totalResults.value += total));

    const chart = {
      data: [],
      backgroundColor: [],
    };

    // Generate the total and chart data.
    totals.value = therapyResult.value.data.map(({ total, name }, key) => {
      chart.data.push(total);
      chart.backgroundColor.push(colors[key].hex);

      return {
        total: new Intl.NumberFormat().format(total),
        percent: formatPercent(total),
        name,
        style: colors[key].style,
      };
    });

    // Pass along the generated chart data that should be displayed.
    defineChartData(chart);
  }
};

const defineChartData = (chart) => (chartData.value.datasets[0] = chart);

const formatPercent = (total: number) => `${((total / totalResults.value) * 100).toFixed()}%`;

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-base text-color-secondary flex-1" }, "Attendance", -1)),
      _withDirectives(_createVNode(_component_Icon, {
        name: "info",
        class: "text-gray-400 text-base cursor-pointer"
      }, null, 512), [
        [
          _directive_tooltip,
          
          'Attendance totals of all documented Sessions, Consultations, and Evaluations in the selected date range.'
        ,
          void 0,
          { left: true }
        ]
      ])
    ]),
    (hasTotals.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Chart), {
            type: "doughnut",
            data: chartData.value,
            class: "attendance flex align-items-center bg-white mr-3 p-2 pt-0 border-circle"
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "flex gap-2 mb-2"
              }, [
                _createVNode(_component_Icon, {
                  name: "circle",
                  class: _normalizeClass(`text-color-${item.style} text-xs`)
                }, null, 8, ["class"]),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} text-xs flex-1`),
                  textContent: _toDisplayString(item.name)
                }, null, 10, _hoisted_5),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} font-bold text-sm`),
                  textContent: _toDisplayString(item.total)
                }, null, 10, _hoisted_6),
                _createElementVNode("span", {
                  class: _normalizeClass(`text-color-${item.style} text-xs text-right w-2rem`),
                  textContent: _toDisplayString(item.percent)
                }, null, 10, _hoisted_7)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-color-grey text-xs flex-1" }, "Total", -1)),
              _createElementVNode("span", {
                class: "text-color-grey font-bold text-sm",
                textContent: _toDisplayString(absoluteTotal.value)
              }, null, 8, _hoisted_9)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_10, [
          (_unref(therapyResult).loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Searching for Attendance Totals"))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "No data for Attendance Totals"))
        ]))
  ]))
}
}

})